import useToast from 'components/hooks/useToast';
import { StyledMenuItem } from './NavigationMenu.style';
import copy from 'copy-to-clipboard';
import { LinkIcon, Tooltip } from '@linearb/linui-common';
import useSelectedFilterSet from '../../../../../../hooks/useSelectedFilterSet';
import { SAVED_FILTER_SET_VISIBILITIES } from '@linearb/linjs-common';
import { getFilterSetTypeText } from '../../../../FilterSet/filter-set.utils';

const CopyUrlToClipboardMenuItem = ({ Context }) => {
  const selectedFilterSet = useSelectedFilterSet(Context);
  const toast = useToast();

  const filterSetTypeText = getFilterSetTypeText(selectedFilterSet);
  const filterSetTypeTextPlural = `${filterSetTypeText}s`;

  const isDisabled =
    selectedFilterSet?.visibility !== SAVED_FILTER_SET_VISIBILITIES.PUBLIC;

  const onClick = () => {
    copy(window.location.href);
    toast({
      message: 'URL was copied to your clipboard',
      autoHideDuration: 1500
    });
  };
  return (
    <Tooltip
      title={
        isDisabled &&
        `Sharing is restricted to public ${filterSetTypeTextPlural}`
      }
      placement='top'
      sx={{ fontSize: '3rem' }}
    >
      <span>
        <StyledMenuItem onClick={onClick} disabled={isDisabled}>
          <LinkIcon />
          Copy link to clipboard
        </StyledMenuItem>
      </span>
    </Tooltip>
  );
};

export default CopyUrlToClipboardMenuItem;
